export enum ProviderType { 
    SIMPLEX = 'SIMPLEX', 
    KRIPTONMARKET = 'KRIPTONMARKET',
    ONRAMPER = 'ONRAMPER',
    COINCAEX = 'COINCAEX' 
};